import React, {Component} from 'react';
import FloatContainer from '../../components/dummy/FloatContainer';
import BrokerZip from './../../utils/Forms/BrokerZip.zip';

class QuotePage extends Component {
    componentDidMount() {
        require('./OneMessage.css');
    }
    render() {
        return (
            <div>
                <div className="One_Message_Container">

                <p className="One_Message_Body">
                    We want to make quoting as simple as possible. 
                    <br></br>Please read through the checklist and make sure you have every required item in order to speed up the quoting process.
                    <br></br>We can quote within 72 hours for most group sizes when provided accurate and complete information.
                    <br></br>Please reach out to our underwriting department if you have any questions regarding the quoting process. 
                    <br></br>Phone: <a className="One_Link" href="tel:801-715-7032">801-715-7032</a>
                        <br></br>Email: <a className="One_Link" href="mailto:rfp@matrixhc.com">rfp@matrixhc.com</a>
                </p>
                </div>
                <div className="One_Message">
                    <ol className="One_List">
                        <h3>Required Checklist</h3>
                        <li>A Census 
                            <ul><li>Including Name of Group, Group Address, Group Size</li></ul></li>
                            <li>A Current summary of benefits 
                                <ul><li>new groups please add your requested benefits</li></ul> </li>
                            <li>Current and renewal rates</li>
                            <li>Premium and claims experience (For groups with 100+ or more enrolled)</li>
                            <li>A bill</li>
                            <li>A desired due date for your quote</li>
                            <li>Requested effective date</li>
                            <li>Any additional benefit requests or contributions</li>
                            <li>Requested commission</li>
                    </ol>
                    <ol className="One_List">
                        <h3>Optional Information</h3>
                        <li>Reason for quoting new coverage?</li>
                        <li>Primary goal for new coverage?
                            <ul><li>For Example: Lower premiums, lower deductibles, higher annual maximums, etc…</li></ul> 
                        </li>
                        <li>Any other relevant group information </li>

                    </ol>
                </div>
                <hr></hr>
                <FloatContainer>
                        <div className="Float_Content_Centered">
                            <h4>Ready to Quote Matrix?</h4>
                            <ul style={{listStyleType: "none"}} >
                                <li>
                                <a href={BrokerZip} target="_blank" rel="noopener noreferrer">Broker Appointment Forms</a>
                                </li>
                            </ul>
                        </div>
                        <div className="Float_Content_Centered">
                            <h4>Have Questions?</h4>
                            <p>Reach out to Trisha Germain at <a href="tel:(801)631-0857">(801)631-0857</a></p>
                        </div>
                        <div className="Float_Content_Centered">
                            <h4>Plans Available</h4>
                            <p>Dental PPO, Dental Copay, Vision Reimbursement</p>
                        </div>
                    </FloatContainer>
            </div>
        )
    }
}
export default QuotePage;